exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".spinner{margin-top:1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-09f63054!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/spinner.vue
// module id = 77
// module chunks = 0